import __request__ from "routing/request";
export function generateClusterDebugEvent(text, requestOptions) {
  return __request__("POST", "/system/debug/events/cluster", text, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function showLastClusterDebugEvent(requestOptions) {
  return __request__("GET", "/system/debug/events/cluster", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function generateDebugEvent(text, requestOptions) {
  return __request__("POST", "/system/debug/events/local", text, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function showLastDebugEvent(requestOptions) {
  return __request__("GET", "/system/debug/events/local", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
